(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archivo-brands"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement del carrusel del archivo: el scroll-snap ya
  // funciona solo, esto suma flechas y barra de progreso cuando hay JS.
  if (!customElements.get('archive-carousel')) {
    class ArchiveCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.thumb = this.querySelector('[data-rail-thumb]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.frame = 0;
        this.pending = null;
        this.pendingTimer = 0;

        this.onScroll = this.onScroll.bind(this);
        this.sync = this.sync.bind(this);

        this.querySelectorAll('[data-nav], [data-rail]').forEach((el) => {
          el.hidden = false;
        });

        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(this.sync);
        this.resizeObserver.observe(this.track);

        this.sync();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.track?.removeEventListener('scroll', this.onScroll);
        cancelAnimationFrame(this.frame);
        clearTimeout(this.pendingTimer);
      }

      /** Ancho de una ficha más el gap, para avanzar de a una. */
      get stepSize() {
        const card = this.track.querySelector('li');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      step(direction) {
        // Cada click arranca desde el destino del anterior y no desde dónde
        // está el scroll: si no, dos clicks seguidos cancelan el scroll suave a
        // mitad de camino y el scroll-snap devuelve la ficha a su lugar.
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const from = this.pending ?? this.track.scrollLeft;
        const to = Math.max(0, Math.min(from + this.stepSize * direction, maxScroll));

        this.pending = to;
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => {
          this.pending = null;
        }, 600);

        this.track.scrollLeft = to;
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.sync);
      }

      sync() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;

        // Sin desborde no hay nada que pasar: se esconden flechas y barra.
        const overflows = maxScroll > 1;
        this.querySelectorAll('[data-nav], [data-rail]').forEach((el) => {
          el.hidden = !overflows;
        });
        if (!overflows) return;

        // scrollLeft es negativo en RTL, así que se mide el avance en absoluto.
        const progress = Math.min(Math.abs(scrollLeft) / maxScroll, 1);
        const ratio = clientWidth / scrollWidth;

        if (this.thumb) {
          this.thumb.style.width = `${ratio * 100}%`;
          this.thumb.style.transform = `translateX(${(progress * (1 - ratio) * 100) / ratio}%)`;
        }

        if (this.prev) this.prev.disabled = progress <= 0.001;
        if (this.next) this.next.disabled = progress >= 0.999;
      }
    }

    customElements.define('archive-carousel', ArchiveCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
